import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  WORKSPACE_REPLAY_FAILURE_EVENT,
  type WorkspaceReplayFailureDetail,
} from '@/lib/offline/sync';
import { useToast } from '@/lib/toast';

export function WorkspaceReplayToastBridge() {
  const { t } = useTranslation('shiftbook');
  const toast = useToast();

  useEffect(() => {
    const onReplayFailure = (event: Event) => {
      const detail = (event as CustomEvent<WorkspaceReplayFailureDetail>).detail;
      toast.error(
        detail?.displayHeading
          ? t('dialog.unsaved.replayFailedDescription', {
              title: detail.displayHeading,
            })
          : t('dialog.unsaved.replayFailedDescriptionGeneric'),
        {
          title: t('dialog.unsaved.replayFailedTitle'),
          duration: 6000,
        },
      );
    };

    window.addEventListener(WORKSPACE_REPLAY_FAILURE_EVENT, onReplayFailure as EventListener);
    return () => {
      window.removeEventListener(WORKSPACE_REPLAY_FAILURE_EVENT, onReplayFailure as EventListener);
    };
  }, [t, toast]);

  return null;
}
